import { Grid, Typography, TextField, Button, Link} from '@mui/material'
import React from 'react'
import ButtonGroup from '../../../../general/ButtonGroup';
import colors from '../../../../colors';
import { determineUtilityRequest } from '../DetermineUtilityRequest'
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import { selectTaksatState } from '../../../../../features/taksat/taksatSlice';
import { selectMyContractsState, setShouldFillFields } from '../../../../../features/myContracts/myContractsSlice';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { texts } from '../../../../general/texts';

export const Taksat = (props) => {

    const taksatSliceState = useSelector(selectTaksatState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const navigate = useNavigate()

    const searchMethods = [
        { display: texts["title-nuis"], value:'1'},
        { display: texts["title-administrator"], value:'2'}
    ]

    const dispatch = useDispatch()

    const[state, setState] = React.useState({
        utilityName: props.utilityName,
        selectedSearchMethod: searchMethods[0].value,
        token: props.globalDataSliceState.token,
        localCode: '',
        nuis: '',
        name: ''
    })

    const getSearchMethodValue = (value) => 
    {
        setState({
            ...state,
            selectedSearchMethod: value
        })
    }

    const handleTextFieldChange = (prop) => (e) => 
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    const utilityRequest = determineUtilityRequest(state)

    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        width:'150px',
        height:'40px',
        fontFamily:'GerberaBold',
        textTransform:'none',
        fontSize:'1rem',
        border: '2px solid'+colors.orange,
        borderRadius:'10px',
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}                 
    }

    const defaultButtonStyle =
    {
        backgroundColor: colors.lightBlue,
        width:'150px',
        height:'40px',
        borderRadius:'10px',
        textTransform:'none',
        fontFamily:'GerberaLight',
        fontSize:'1rem',
        color: colors.darkBlue,
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)' : {width:'130px', height:'40px'}      
    }

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                localCode: props.selectedContractInfo.contract,
                nuis: props.selectedContractInfo.description,
                name: props.selectedContractInfo.optional
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])
    
    

    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor:colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            fontSize:'1rem',
            textTransform:'none',
            background:colors.gradientOrange,
            fontFamily:'GerberaBold'
        },
        buttonGrid:{
            marginTop:'10%',
            paddingBottom:'5%'
        },
        image:{
            width:'45%'
        },
        textField:{
            width:'100%'
        }
    })

    const classes = useStyles()

  return (
    <Grid container item className={classes.mainGrid}  rowSpacing={3}>
        <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
        <Grid container item md={12} xs={12}>
            <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
            <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
        </Grid>
        <Grid container item md={12} xs={12} >
            <Typography className={classes.fieldTitle} >{texts["prompt-choose-search-method"]}</Typography>
        </Grid>
        <Grid container item md={12} xs={12} justifyContent='flex-start' columnSpacing={5} rowSpacing={3}>
            <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue}/> 
        </Grid>
        {state.selectedSearchMethod === '1' &&
            <Grid container item rowSpacing={3} >
                <Grid item md={12} xs={12} >
                    <Typography className={classes.fieldTitle}>{texts["placeholder-nuis"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('nuis')} value={state.nuis} color='warning' size='small' label={texts["placeholder-nuis"]} sx={{width:'100%'}} />
                </Grid>
            </Grid>
        }
        {state.selectedSearchMethod === '2' &&
            <Grid container item rowSpacing={3} >
                <Grid item md={12} xs={12} >
                    <Typography className={classes.fieldTitle}>{texts["title-administrator"]}</Typography>
                </Grid>
                <Grid item md={12} xs={12} >
                    <TextField onChange={handleTextFieldChange('name')} value={state.name} color='warning' size='small' label={texts["placeholder-administrator"]} sx={{width:'100%'}} />
                </Grid>
            </Grid>
        }
        <Grid container item rowSpacing={3} >
            <Grid item md={12} xs={12} >
                <Typography className={classes.fieldTitle}>{texts["placeholder-local-code"]}</Typography>
            </Grid>
            <Grid item md={12} xs={12} >
                <TextField onChange={handleTextFieldChange('localCode')} value={state.localCode} color='warning' size='small' label={texts["placeholder-local-code"]} sx={{width:'100%'}} />
            </Grid>
            <Grid item md={12} xs={12} className={classes.buttonGrid} >
                <Button disabled={taksatSliceState.isLoading ? true : false} onClick={()=>{dispatch(utilityRequest)}} className={classes.button}>{texts["title-search"]}</Button>
            </Grid>
        </Grid>
    </Grid>
  )
}
export default Taksat